import {
  GET_LABREQUESTSURVEY,
  GET_LABREQUESTSURVEY_FAIL,
  GET_LABREQUESTSURVEY_SUCCESS,
  GET_LABREQUESTSURVEYS,
  GET_LABREQUESTSURVEYS_FAIL,
  GET_LABREQUESTSURVEYS_SUCCESS,
  ADD_NEW_LABREQUESTSURVEY,
  ADD_LABREQUESTSURVEY_SUCCESS,
  ADD_LABREQUESTSURVEY_FAIL,
  UPDATE_LABREQUESTSURVEY,
  UPDATE_LABREQUESTSURVEY_SUCCESS,
  UPDATE_LABREQUESTSURVEY_FAIL,
  DELETE_LABREQUESTSURVEY,
  DELETE_LABREQUESTSURVEY_SUCCESS,
  DELETE_LABREQUESTSURVEY_FAIL,
  SET_STATE_LABREQUESTSURVEY,
  GET_LABREQUESTSURVEYSCALCULATE,
  GET_LABREQUESTSURVEYSCALCULATE_SUCCESS,
  GET_LABREQUESTSURVEYSCALCULATE_FAIL
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_LABREQUESTSURVEY,
  payload: loading,
})

export const getLabRequestSurveys = ( params ) => ({
  type: GET_LABREQUESTSURVEYS,
  payload: { params },
})

export const getLabRequestSurveysSuccess = (labRequestSurveys, totalPages, currentPage) => ({
  type: GET_LABREQUESTSURVEYS_SUCCESS,
  payload: { labRequestSurveys:labRequestSurveys, total:totalPages, currentPage:currentPage}
})

export const getLabRequestSurveysFail = error => ({
  type: GET_LABREQUESTSURVEYS_FAIL,
  payload: error,
})

export const getLabRequestCalculateSurveys = ( params ) => ({
  type: GET_LABREQUESTSURVEYSCALCULATE,
  payload: { params },
})

export const getLabRequestSurveysCalculateSuccess = (labRequestSurveysCalculate) => ({
  type: GET_LABREQUESTSURVEYSCALCULATE_SUCCESS,
  payload: { labRequestSurveysCalculate:labRequestSurveysCalculate}
})

export const getLabRequestSurveysCalculateFail = error => ({
  type: GET_LABREQUESTSURVEYSCALCULATE_FAIL,
  payload: error,
})

export const addNewLabRequestSurvey = labRequestSurvey => ({
  type: ADD_NEW_LABREQUESTSURVEY,
  payload: labRequestSurvey,
})

export const addLabRequestSurveySuccess = labRequestSurvey => ({
  type: ADD_LABREQUESTSURVEY_SUCCESS,
  payload: labRequestSurvey,
})  

export const addLabRequestSurveyFail = error => ({
  type: ADD_LABREQUESTSURVEY_FAIL,
  payload: error,
})

export const updateLabRequestSurvey = labRequestSurvey => ({
  type: UPDATE_LABREQUESTSURVEY,
  payload: labRequestSurvey,
})

export const updateLabRequestSurveySuccess = labRequestSurvey => ({
  type: UPDATE_LABREQUESTSURVEY_SUCCESS,
  payload: labRequestSurvey,
})

export const updateLabRequestSurveyFail = error => ({
  type: UPDATE_LABREQUESTSURVEY_FAIL,
  payload: error,
})

export const deleteLabRequestSurvey = labRequestSurvey => ({
  type: DELETE_LABREQUESTSURVEY,
  payload: labRequestSurvey,
})

export const deleteLabRequestSurveySuccess = id => ({
  type: DELETE_LABREQUESTSURVEY_SUCCESS,
  id,
})

export const deleteLabRequestSurveyFail = error => ({
  type: DELETE_LABREQUESTSURVEY_FAIL,
  payload: error,
})

export const getLabRequestSurvey = () => ({
  type: GET_LABREQUESTSURVEY,
})

export const getLabRequestSurveySuccess = labRequestSurvey => ({
  type: GET_LABREQUESTSURVEY_SUCCESS,
  payload: labRequestSurvey,
})

export const getLabRequestSurveyFail = error => ({
  type: GET_LABREQUESTSURVEY_FAIL,
  payload: error,
})
